import { lazy } from 'react';

// Map component names to dynamic imports
export const componentMapping = {
    Dashboard: lazy(() => import("../pages/Dashboard")),
    ChartReportPage: lazy(() => import("../pages/ChartReportPage")),
    SubeListPagev2: lazy(() => import("../pages/sube/SubeListPagev2")),
    TescilListPagev2: lazy(() => import("../pages/tescil/TescilListPagev2")),
    ViziteListPagev2: lazy(() => import("../pages/vizite/ViziteListPagev2")),
    ViziteRaporPagev2: lazy(() => import("../pages/vizite/ViziteRaporPagev2")),
    EViziteOnayLogListPage: lazy(() => import("../pages/vizite/EViziteOnayLogListPage")),
    EviziteMahsupPage: lazy(() => import('../pages/vizite/EviziteMahsupPage')),
    KazaListPagev2: lazy(() => import("../pages/kaza/KazaListPagev2")),
    Bildirimsizler: lazy(() => import("../pages/kaza/Bildirimsizler")),
    KazaBildirimListPageV2: lazy(() => import("../pages/kaza/KazaBildirimListPageV2")),
    BorcListPagev2: lazy(() => import("../pages/borc/BorcListPagev2")),
    KullanicilariPage: lazy(() => import("../pages/yetki/KullanicilariPage")),
    ViziteMailAlicilariPage: lazy(() => import("../pages/vizite/ViziteMailAlicilariPage")),
    EViziteMonitorWSListPage: lazy(() => import("../pages/vizite/EViziteMonitorWSListPage")),
    EViziteOnayliMonitorWSListPage: lazy(() => import("../pages/vizite/EViziteOnayliMonitorWSListPage")),
    EViziteMahsupMonitorPage: lazy(() => import("../pages/vizite/EViziteMahsupMonitorPage")),
    IsKazasiMonitorWSListPage: lazy(() => import("../pages/kaza/IsKazasiMonitorWSListPage")),
    IsKazasiMonitorListPage: lazy(() => import("../pages/kaza/IsKazasiMonitorListPage")),
    IsKazasiBatchMonitorListPage: lazy(() => import("../pages/kaza/IsKazasiBatchMonitorListPage")),
    EBorcuYokturMonitorPage: lazy(() => import("../pages/borc/EBorcuYokturMonitorPage")),
    EBorcBatchMonitorPage: lazy(() => import("../pages/borc/EBorcBatchMonitorPage")),
    CalismaTakvimiPage: lazy(() => import("../pages/ozellik/CalismaTakvimiPage")),
    PeriodsPage: lazy(() => import("../pages/ozellik/PeriodsPage")),
    SirketlerPage: lazy(() => import("../pages/borc/SirketlerPage")),
    MenulerIconPage: lazy(() => import("../pages/config/MenulerIconPage")),
    MenulerYolPage: lazy(() => import("../pages/config/MenulerYolPage")),
    MenulerPage: lazy(() => import("../pages/config/MenulerPage")),
    TesvikOptimizasyonPagev2: lazy(() => import("../pages/tesvik/TesvikOptimizasyonPagev2")),
    TesvikPagev2: lazy(() => import("../pages/tesvik/TesvikPagev2")),
    RaporListPagev2: lazy(() => import("../pages/rapor/RaporListPagev2")),
    AsgariUcretDestegiRaporPage: lazy(() => import("../pages/aud/AsgariUcretDestegiRaporPage")),
    SablonlarPage: lazy(() => import("../pages/Ebasvuru/SablonlarPage")),
    AdayTestPage: lazy(() => import("../pages/testmerkezi/adaytest/AdayTestPage")),
    FaktorPage: lazy(() => import("../pages/testmerkezi/faktor/FaktorPage")),
    TestTipPage: lazy(() => import("../pages/testmerkezi/testtip/TestTipPage")),
    TedarikciPage: lazy(() => import("../pages/testmerkezi/tedarikci/TedarikciPage")),
    TestMerkeziPage: lazy(() => import("../pages/testmerkezi/TestMerkeziPage")),
    SablonTipleriPage: lazy(() => import("../pages/Ebasvuru/SablonTipleriPage")),
    SablonParametrePage: lazy(() => import("../pages/Ebasvuru/SablonParametrePage")),
    AUDDonemPersonelSayisiPage: lazy(() => import("../pages/aud/AUDDonemPersonelSayisiPage")),
    AUDIsyeriGunSayilariPage: lazy(() => import("../pages/aud/AUDIsyeriGunSayilariPage")),
    AUDTesviklerPage: lazy(() => import("../pages/aud/AUDTesviklerPage")),
    SysRolPage: lazy(() => import("../pages/config/SysRolPage")),
    BolgelerPage: lazy(() => import("../pages/bolge/BolgelerPage")),
    SgkArsivPage: lazy(() => import("../pages/arsiv/SgkArsivPage")),
    MailGrupViziteAliciPage: lazy(() => import("../pages/config/MailGrupViziteAliciPage")),
    MailGruplariPage: lazy(() => import("../pages/config/MailGruplariPage")),
    SGKParameterPage: lazy(() => import("../pages/config/SGKParameterPage")),
    AdayIdxRootPage: lazy(() => import("../pages/Ebasvuru/BasvuruYonetim/AdayIdxRootPage")),
    TenantBatchOperationPage: lazy(() => import("../pages/master/TenantBatchOperationPage")),
    HangfireLoglamaPage: lazy(() => import("../pages/master/HangfireLoglamaPage")),
    WorkerPlannedJobPage: lazy(() => import("../pages/master/WorkerPlannedJobPage")),
    SGKMasterParameterPage: lazy(() => import("../pages/master/SGKMasterParameterPage")),
    BasvurularPage: lazy(() => import("../pages/Ebasvuru/BasvuruYonetim/BasvurularPage")),
    TescilGirisKontrolPage: lazy(() => import("../pages/tescil/TescilGirisKontrolPage")),
    TescilCikisKontrolPage: lazy(() => import("../pages/tescil/TescilCikisKontrolPage")),
    KriterKategoriPage: lazy(() => import("../pages/Ebasvuru/BasvuruYonetim/KriterKategoriPage")),
    TescilParametreleriPage: lazy(() => import("../pages/tescil/TescilParametreleriPage")),
    SoruSetiPage: lazy(() => import("../pages/aksiyon/SoruSetiPage")),
    SorularPage: lazy(() => import("../pages/aksiyon/SorularPage")),
    KullaniciCevaplarPage: lazy(() => import("../pages/aksiyon/KullaniciCevaplarPage")),
    AksiyonLogPage: lazy(() => import("../pages/aksiyon/AksiyonLogPage")),
    ArsProjelerPage: lazy(() => import("../pages/aksiyon/ArsProjelerPage")),
    KriteraltKategoriPage: lazy(() => import("../pages/Ebasvuru/BasvuruYonetim/KriteraltKategoriPage")),
    KriterSecenekSablonuPage: lazy(() => import("../pages/Ebasvuru/BasvuruYonetim/KriterSecenekSablonuPage")),
    KriterTanimlariPage: lazy(() => import("../pages/Ebasvuru/BasvuruYonetim/KriterTanimlariPage")),
    KriterKomponentPage: lazy(() => import("../pages/Ebasvuru/BasvuruYonetim/KriterKomponentPage")),
    KriterModulPage: lazy(() => import("../pages/Ebasvuru/BasvuruYonetim/KriterModulPage")),
    BasvuruFormuPage: lazy(() => import("../pages/Ebasvuru/BasvuruYonetim/BasvuruFormuPage")),
    KriterGrubuPage: lazy(() => import("../pages/Ebasvuru/BasvuruYonetim/KriterGrubuPage")),
    RecievedSMSPage: lazy(() => import("../pages/smart/RecievedSMSPage")),
    KampanyaYonetimiPage: lazy(() => import("../pages/ikisealim/KampanyaYonetimiPage")),
    AdayKategorileriPage: lazy(() => import("../pages/ik/AdayKategorileriPage")),
};
